import React, { useEffect, useRef, useState } from 'react';
import { Waypoint } from 'react-waypoint';

import './SeeItAll.scss';

import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import { ScrollLottie } from '../../util/vendor/ScrollLottie';

const SeeItAll = ({ heading, desc, ctaText, ctaLink, videoLink, image }) => {
  const [firstRender, setFirstRender] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const videoElement = useRef();

  useEffect(() => {
    setFirstRender(false);
    firstRender &&
      ScrollLottie({
        target: '.c-see-it-all__circle-progress-icon',
        duration: 1,
        speed: 'medium',
      });
  }, [firstRender]);

  const togglePlaying = (el) => (isPlaying ? el.pause() : el.play());

  return (
    <div className="c-see-it-all">
      <div className="c-see-it-all__content">
        <div className="c-see-it-all__image-container">
          <img src={image.url} alt={image.alt} />
        </div>
        <Waypoint
          onEnter={() => {
            setIsPlaying(true);
            togglePlaying(videoElement.current);
          }}
          onLeave={() => {
            setIsPlaying(false);
            togglePlaying(videoElement.current);
          }}
        >
          <video
            ref={videoElement}
            className="c-see-it-all__video"
            src={videoLink}
            autoPlay={true}
            muted={true}
            loop={true}
            playsInline={true}
          >
            <source src={videoLink} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
          </video>
        </Waypoint>
        <div className="c-see-it-all__circle-progress-icon"></div>
        <div className="c-see-it-all__text">
          <h4 className="c-see-it-all__heading h3-right-grotesk">{heading}</h4>
          <p className="c-see-it-all__desc h3-roobert">{desc}</p>
          {ctaText && (
            <CTAButton
              text={ctaText}
              link={ctaLink}
              target="_self"
              type="primary"
              additionalClasses="c-see-it-all__cta cta"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SeeItAll;
